/**
 * @packageDocumentation
 * @module      CorNavBar.ts
 * @description The navigation bar for this application.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property } from 'lit-element';
import LoggedInUser from "./LoggedInUser";
export var CorNavBarTab;
(function (CorNavBarTab) {
    CorNavBarTab[CorNavBarTab["None"] = 0] = "None";
    CorNavBarTab[CorNavBarTab["RoboticNetworks"] = 1] = "RoboticNetworks";
    CorNavBarTab[CorNavBarTab["Systems"] = 2] = "Systems";
    CorNavBarTab[CorNavBarTab["UserManagement"] = 3] = "UserManagement";
    CorNavBarTab[CorNavBarTab["AuditLogs"] = 4] = "AuditLogs";
})(CorNavBarTab || (CorNavBarTab = {}));
/** The navigation bar for this application. */
let CorNavBar = class CorNavBar extends LitElement {
    constructor() {
        super(...arguments);
        /** The tab that the user has selected. */
        this.activeTab = CorNavBarTab.None;
    }
    /**
     * Get the HTML ID to use for the given tab.
     *
     * @param tab One of the enumerated values in {@linkcode CorNavBarTab}
     *
     * @returns A string to use for the HTML ID attribute of the tab. Example: "NavBarTab_Systems".
     */
    getTabId(tab) {
        return "NavBarTab_" + CorNavBarTab[tab];
    }
    /** Renders the component as part of LitElement's lifecycle. */
    render() {
        function menuChoice(tab, text) {
            return { tab: tab, text: text };
        }
        let choices = [];
        if (LoggedInUser.isSystemAdmin()) {
            choices.push(menuChoice(CorNavBarTab.RoboticNetworks, "Robotic Networks"));
            choices.push(menuChoice(CorNavBarTab.Systems, "Systems"));
        }
        if (LoggedInUser.isUserAdmin()) {
            choices.push(menuChoice(CorNavBarTab.UserManagement, "User Management"));
        }
        if (LoggedInUser.isSystemAdmin()) {
            choices.push(menuChoice(CorNavBarTab.AuditLogs, "Audit Logs"));
        }
        return html `
            <sh-nav-bar>
                <sh-tabs>
                    ${choices.map(choice => {
            return html `
                            <sh-tab-item
                                    id=${this.getTabId(choice.tab)}
                                    label="${choice.text}"
                                    @click=${() => {
                this.dispatchEvent(new CorNavTabChangedEvent(choice.tab));
            }}
                                    ?active="${this.activeTab == choice.tab}">${choice.text}
                            </sh-tab-item>`;
        })}
                </sh-tabs>
            </sh-nav-bar>
        `;
    }
};
__decorate([
    property()
], CorNavBar.prototype, "activeTab", void 0);
CorNavBar = __decorate([
    customElement('cor-nav-bar')
], CorNavBar);
export default CorNavBar;
/**
 * An event that {@linkcode CorNavBar} will fire when a new tab becomes active.
 */
export class CorNavTabChangedEvent extends CustomEvent {
    /**
     * Constructor.
     *
     * @param navTab The tab that has just become active.
     */
    constructor(navTab) {
        super(CorNavTabChangedEvent.eventName, {
            bubbles: true,
            composed: true,
            detail: CorNavBarTab[navTab]
        });
    }
    /** Convenience method for obtaining the tab that has just become active. */
    getNavTab() {
        var _a;
        // @ts-ignore
        return (_a = CorNavBarTab[this.detail]) !== null && _a !== void 0 ? _a : CorNavBarTab.RoboticNetworks;
    }
}
CorNavTabChangedEvent.eventName = "navTabChanged";
//# sourceMappingURL=CorNavBar.js.map